import * as angular from "angular";
import {IQService} from "angular";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import {PrinterService} from "../../commons/services/printer-service.service";

export class OrdersDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $q: IQService, private confirmDialogService: ConfirmDialogService, private $translate) {
  }

  // ******************************
  // External methods
  // ******************************

  orderCreatedSuccessfully(event, order) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/order-created-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.order = order;

        //////////////////////

        $scope.ok = () => {
          self.$mdDialog.hide();
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }
      }
    });
  }

  confirmOrderPrice(event, orderPrice, billingAccount) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/confirm-order-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.orderPrice = orderPrice;
        $scope.currency = orderPrice.currencyCode;
        $scope.paymentMethod = billingAccount.defaultPaymentMethod;
        $scope.paymentMethods = billingAccount.paymentMethods;
        $scope.billingAccount = billingAccount;

        //////////////////////

        $scope.hide = () => {
          self.$mdDialog.hide($scope.paymentMethod);
        };

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        };
      }

    });
  }

  confirmOrderSummary(event, orderPrice) {
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: '<confirm-order-summery-dialog order-price="ctrl.orderPrice" on-submit="ctrl.submit()" on-cancel="ctrl.cancel()"></confirm-order-summery-dialog>',
      controllerAs: 'ctrl',
      targetEvent: event,
      autoWrap: false,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function($mdDialog) {
        this.orderPrice = orderPrice;
        this.currency = orderPrice.currencyCode;

        this.submit = () => {
          $mdDialog.hide();
        };

        this.cancel = () => {
          $mdDialog.cancel();
        };
      },
    });
  }

  confirmCustomers(event, shouldCreateNewCustomer, isCustomizedCustomerAddress, defaultCustomerAddressChanged) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/confirm-customers-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.answers = {
          createNewAnswer: {
            pickup: false,
            dropoff: false
          },
          customizeAddressAnswer: {
            pickup: false,
            dropoff: false
          },
          defaultAddressAnswer: {
            pickup: false,
            dropoff: false
          }
        };

        $scope.customersConfig = {
          createNew: {
            enabled: shouldCreateNewCustomer.pickup || shouldCreateNewCustomer.dropoff,
            purpose: {
              pickup: shouldCreateNewCustomer.pickup,
              dropoff: shouldCreateNewCustomer.dropoff
            }
          },
          customizeAddress: {
            enabled: isCustomizedCustomerAddress.pickup || isCustomizedCustomerAddress.dropoff,
            purpose: {
              pickup: isCustomizedCustomerAddress.pickup,
              dropoff: isCustomizedCustomerAddress.dropoff
            }
          },
          defaultAddress: {
            enabled: defaultCustomerAddressChanged.pickup || defaultCustomerAddressChanged.dropoff,
            purpose: {
              pickup: defaultCustomerAddressChanged.pickup || false,
              dropoff: defaultCustomerAddressChanged.dropoff || false
            }
          }
        };

        //////////////////////

        $scope.hide = () => {
          self.$mdDialog.hide($scope.answers);
        };

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        };
      }

    });
  }

  printingDialog(event?, delivery?, printer?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/printing-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, printerService: PrinterService) {

        $scope.print = () => {
          printerService.printDelivery(delivery, printer);
        };

        $scope.complete = () => {
          self.$mdDialog.hide();
        };
      },

    });
  }

  outOfServiceZone(event, fromAddress, toAddress, accountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/out-of-service-zone.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.fromAddress = fromAddress;
        $scope.toAddress = toAddress;
        $scope.accountId = accountId;

        //////////////////////

        $scope.ok = () => {
          self.$mdDialog.hide();
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }
      }
    });
  }

  orderCreateAllowedDebitError(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/order-create-allowed-debit-error.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        //////////////////////

        $scope.ok = () => {
          self.$mdDialog.hide();
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }
      }

    });
  }

  // ******************************
  // Internal methods
  // ******************************

  removeRecordConfirmationDialog(event) {
    const deferred = this.$q.defer();

    this.confirmDialogService.confirm('Confirm Delivery Removal',
      'Are you sure you want to remove the delivery record from the order?', event)
      .then(deferred.resolve, deferred.reject);

    return deferred.promise;
  }

  backToOrderConfirmationDialog(event) {
    const deferred = this.$q.defer(),
      content = [
        'Back to Order View',
        'Are you sure you want to leave this page? Progress will be lost!'
      ];

    this.$translate(content)
      .then((translatedContent) => {

          const title = translatedContent[content[0]];
          const textContent = translatedContent[content[1]];

          this.confirmDialogService.confirm(title, textContent, event)
            .then(deferred.resolve, deferred.reject);
        }
      );

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.orders')
  .service('ordersDialogService', OrdersDialogService);
